import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import SubmodalityForm from '../components/forms/SubmodalityForm';
import '../styles/EmployeeMaster.css';
import SubmodalityTable from '../components/SubmodalityTable';

const SubmodalityEditModel = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [submodalityData, setSubmodalityData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /submodality/edit
  const showModal = location.pathname.startsWith('/submodality/edit');

  const handleCloseModal = () => {
    navigate('/submodality'); // Go back to list
  };

  // ✅ Fetch Submodality details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getSubModalityById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            // Backend may return data as array or object, handle both
            const payload = Array.isArray(data.data) ? data.data[0] : data.data;
            setSubmodalityData(payload);
          } else {
            setSubmodalityData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching Submodality by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal, baseUrl]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Submodality Master</h2>
      </div>

      {/* Table of Submodalities */}
      <SubmodalityTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Submodality</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : submodalityData ? (
            <SubmodalityForm
              subModalityId={id}
              initialData={submodalityData}
              onSuccess={handleCloseModal} // ✅ Close after save
            />
          ) : (
            <p className="text-center">No data found for this Submodality.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubmodalityEditModel;